/*
 * @Description:
 * @Author: leo
 * @Date: 2020-04-08 15:20:27
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-04-20 11:25:09
 */
import md5 from 'md5'
/**
 * 安全格式化json
 *
 * @export
 * @param {*} jsonStr
 */
export function safeJSON(jsonStr) {
  let res = jsonStr

  try {
    res = JSON.parse(jsonStr)
  } catch (e) {
    res = null
    console.log(e)
  }
  return res
}
/**
 * @description 判读设备系统类型
 * @return {Boolean} true or false
 */
export const isIos = function() {
  return (
    (/iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
    !window.MSStream
  )
}

// 是不是安卓平台
export const isAndroid = function() {
  let u = navigator.userAgent
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
  return isAndroid
}

// 手机号正则验证
let phoneEmailTest = /^0?(?:1[123456789][0-9])[0-9]{8}$/
// 邮箱验证
/* eslint-disable */
let rEmail = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
export const validEmail = function(email) {
  return rEmail.test(email)
}
export const validPhone = function(phone) {
  return phoneEmailTest.test(phone)
}

//MD5加密
export const getMd5 = function(data){
  const md5Pwd = md5(data)
  return md5Pwd
}

//localStroge appInfo 、deviceInfo数据格式化
export const localData = function(){
  let appInfo = localStorage.getItem('appInfo')
  let deviceInfo = localStorage.getItem('deviceInfo')
  if (appInfo && deviceInfo) {
    appInfo = JSON.parse(appInfo)
    deviceInfo = JSON.parse(deviceInfo)
  }
  let dataInfo = {
    appInfo:appInfo,
    deviceInfo:deviceInfo
  }
  return dataInfo
}